import React, { createContext, useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const InitialsContext = createContext({
  initials: '',
});

export const InitialsProvider = ({ children }) => {
  const location = useLocation();
  const params = useParams();
  const [initials, setInitials] = useState('');

  useEffect(() => {
    let { initials: paramInitials } = params;

    // If initials somehow undefined, try parsing from pathname
    if (!paramInitials) {
      const parts = location.pathname.split('/');
      paramInitials = parts[parts.length - 1] || parts[parts.length - 2]; // handle trailing slash
    }

    // Remove query string if accidentally included
    paramInitials = paramInitials.split('?')[0];

    setInitials(paramInitials);
  }, [params, location.pathname]);

  return (
    <InitialsContext.Provider value={{ initials }}>
      {children}
    </InitialsContext.Provider>
  );
};

// ✅ Hook to consume context easily
export const useInitials = () => React.useContext(InitialsContext);
